/**
 * Haken vor einem Sprachwechsel (Marcel 01.11.2026: „die Länder stellen sich mit um – das sollte nicht sein“).
 * Der Länderfilter-Kontext friert hier die aktuell wirksame Länderauswahl ein, bevor die Sprache (und damit die
 * sprachabhängige Vorbelegung) wechselt. Außerdem: Merker für das Zusammenfassungs-Popup nach dem Neuladen
 * („Du siehst DartCloud jetzt auf … mit Inhalten aus …“). Keine Imports → von i18n/index.ts aus nutzbar.
 */
type BeforeLanguageChangeHook = () => Promise<void> | void;
const hooks = new Set<BeforeLanguageChangeHook>();
const HOOK_TIMEOUT_MS = 1500;

export const onBeforeLanguageChange = (fn: BeforeLanguageChangeHook): (() => void) => {
  hooks.add(fn);
  return () => { hooks.delete(fn); };
};

/** Alle Haken nacheinander ausführen – nie werfend, je Haken maximal HOOK_TIMEOUT_MS. */
export const runBeforeLanguageChange = async (): Promise<void> => {
  for (const fn of Array.from(hooks)) {
    try {
      await Promise.race([Promise.resolve(fn()), new Promise<void>((resolve) => setTimeout(resolve, HOOK_TIMEOUT_MS))]);
    } catch { /* ein Haken darf den Sprachwechsel nie blockieren */ }
  }
};

/** Nur für Tests. */
export const resetBeforeLanguageChangeHooks = (): void => { hooks.clear(); };

export const SETTINGS_SUMMARY_FLAG = 'dc-settings-summary';

/** Vor dem Neuladen setzen: nach dem Start wird einmal die Zusammenfassung gezeigt. */
export const markSettingsSummaryPending = (): void => {
  try { sessionStorage.setItem(SETTINGS_SUMMARY_FLAG, '1'); } catch { /* egal */ }
};

/** Merker lesen UND löschen (genau ein Popup). */
export const consumeSettingsSummaryPending = (): boolean => {
  try {
    const v = sessionStorage.getItem(SETTINGS_SUMMARY_FLAG);
    if (v) sessionStorage.removeItem(SETTINGS_SUMMARY_FLAG);
    return !!v;
  } catch { return false; }
};
